module.exports = __webpack_public_path__ + "img/2.21398d37.jpg";